export type S3CopyBucketKind = 'documents' | 'imports';

const QA_BUCKETS: Record<S3CopyBucketKind, string> = {
    documents: 'cashbuild-portal-documents-qa',
    imports: 'cashbuild-manual-data-import-qa',
};

const PROD_BUCKETS: Record<S3CopyBucketKind, string> = {
    documents: 'cashbuild-portal-documents-prod',
    imports: 'cashbuild-manual-data-import-prod',
};

function isProdApi(): boolean {
    const uri = import.meta.env.VITE_APOLLO_URI ?? '';
    return (
        uri.includes('portal-api.cashbuild.co.za') &&
        !uri.includes('portal-api-qa')
    );
}

export function getS3BucketName(kind: S3CopyBucketKind): string {
    return isProdApi() ? PROD_BUCKETS[kind] : QA_BUCKETS[kind];
}

export function getS3BucketPrefix(kind: S3CopyBucketKind): string {
    return `${getS3BucketName(kind)}/`;
}

export function getS3ObjectKey(path: string): string {
    const trimmed = path.trim().replace(/^\/+/, '');
    const s3UriMatch = trimmed.match(/^s3:\/\/[^/]+\/(.+)$/i);
    if (s3UriMatch) {
        return s3UriMatch[1];
    }

    const knownBuckets = [
        ...Object.values(QA_BUCKETS),
        ...Object.values(PROD_BUCKETS),
    ];
    const matchingBucket = knownBuckets.find(bucket =>
        trimmed.startsWith(`${bucket}/`),
    );
    if (matchingBucket) {
        return trimmed.slice(`${matchingBucket}/`.length);
    }

    return trimmed;
}
